var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartBagFilledPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#684199",
    fillRule: "evenodd",
    d: "M10 8v1H7.35a2.5 2.5 0 0 0-2.486 2.239l-1.684 16A2.5 2.5 0 0 0 5.666 30h20.667a2.5 2.5 0 0 0 2.487-2.761l-1.684-16A2.5 2.5 0 0 0 24.649 9h-2.65V8a6 6 0 1 0-12 0m6-4a4 4 0 0 0-4 4v1h8V8a4 4 0 0 0-4-4m-4 11a4 4 0 1 0 8 0v-1a1 1 0 0 1 2 0v1a6 6 0 1 1-12 0v-1a1 1 0 0 1 2 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBagFilledPurple);
export default __webpack_public_path__ + "static/media/cart_bag_filled_purple.1d5af5c103de0e6a9288daa640052a41.svg";
export { ForwardRef as ReactComponent };